import './index.scss'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'

const NotFound = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container not-found-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['4', '0', '4', ' ', '-', ' ', 'P', 'a', 'g', 'e', ' ', 'N', 'o', 't', ' ', 'F', 'o', 'u', 'n', 'd']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        Oops! The page you are looking for does not exist.
                    </p>
                    <Link to="/" className="flat-button">
                        BACK TO HOME
                    </Link>
                </div>
            </div>
            <Loader type="ball-scale-multiple" />
        </>
    )
}

export default NotFound
